import Vue from 'vue';
import App from './App.vue';
import router from './router';
import '@/assets/site.css';
import './styles/quasar.styl'
import '@quasar/extras/material-icons/material-icons.css';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Quasar from 'quasar';
import { LocalStorage } from 'quasar';
import interceptors from '@/module/axiosInterceptors';
import Component from 'vue-class-component'
import axios from "axios";
import {CONFIG_ENV} from "@/config";
import VuePageTransition from 'vue-page-transition';
Vue.use(VuePageTransition);
import Carousel3d from 'vue-carousel-3d';
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate' // for vue-router 2.2+
]);
Vue.prototype.$eventHub = new Vue(); // Global event bus
Vue.component('font-awesome-icon', FontAwesomeIcon)



Vue.use (Quasar, {extras: [    'Material-icons',     'Fontawesome' ]})
library.add(faUserSecret)
Quasar.iconSet.set(Quasar.iconSet.fontawesomeV5);

Vue.config.productionTip = false;
Vue.directive('uppercase', {
    update (el:any) {
        el.value = el.value.toUpperCase()
    }
});
Vue.use(Carousel3d);

interceptors();
/*
let isUserAuthenticated = LocalStorage.getItem('isAuthenticated');
let token_for_permanent_session = LocalStorage.getItem('token_for_permanent_session');
let userid = LocalStorage.getItem('userid');
if(isUserAuthenticated=='yes'){
    console.log('%cin main: Se pare ca este autentificat, totusi verificam tokenul cu cel de per server!...','color:blue; font-size:20px;');
    var params = new URLSearchParams();
    params.append('token_for_permanent_session', token_for_permanent_session);
    params.append('userid', userid);
    let res = await axios.post(`${CONFIG_ENV.URL_USER.check_token_for_permanent_session}`,params);
    let data = await res.data;
}
*/
new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
